<template>
  <v-footer
    v-ripple="{ center: true }"
    color="background"
    app
    inset
  >
    <v-container class="pa-0 ma-0 d-flex justify-space-between caption" fluid>
      <div>
        NetWork Team GmbH &copy; {{ new Date().getFullYear() }}
      </div>
      <div>{{ $page.props.release }}</div>
      <div>
        <a href="https://nwt.de/impressum" target="_blank">Impressum</a>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
   props: {
      //
   },
   data: () => ({
      //
   }),
}
</script>
